"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CitationCollection = void 0;
var collections_1 = require("./collections");
/**
 * Collections with relations:
 * Excerpts of publication (also called ouvrages, doctrine) => cite decisions and laws,
 * Decisions => cite laws and decisions,
 * Laws => cite laws,
 * Statistics => cite decisions,
 * Analyses => cite laws.
 * Note: CODE_ARTICLE and LAW_TEXT are both laws.
 */
var CitationCollection;
(function (CitationCollection) {
    CitationCollection["ANALYSES"] = "analyses";
    CitationCollection["ARTICLES"] = "articles";
    CitationCollection["CODE_ARTICLES"] = "codeArticles";
    CitationCollection["DECISIONS"] = "decisions";
    CitationCollection["LAW_TEXTS"] = "laws";
    CitationCollection["PUBLICATION_SHEETS"] = "publicationSheets";
    CitationCollection["STATISTICS"] = "statistics";
    CitationCollection["GLOSSARY_TERMS"] = "glossaryTerms";
})(CitationCollection || (exports.CitationCollection = CitationCollection = {}));
//# sourceMappingURL=citedCollections.js.map